import React from 'react';

export const LocaleContext = React.createContext();



// WEBPACK FOOTER //
// ./src/locale-context.js